<!-- <h2 mat-dialog-title class="dialog-title">
   {{!data.isEdit ? "Inserimento dei turni per l'operatore" : "Modifica dei turni per l'operatore"}}: {{data.operator.name | titlecase}} {{data.operator.surname | titlecase}}
  <button mat-icon-button class="close-button" (click)="onClose()">
    <mat-icon>close</mat-icon>
  </button>
</h2>
<mat-dialog-content>
</mat-dialog-content>
<mat-dialog-actions>
</mat-dialog-actions> -->

<!-- new -->
 <h5 mat-dialog-title>
    {{!data.isEdit ? "Inserimento dei turni" : "Modifica dei turni"}}: {{data.operator.name | titlecase}} {{data.operator.surname | titlecase}}
  </h5>

<mat-dialog-content>
  <form [formGroup]="form">

  @if(!data.isEdit){
    <section class="checbox">
      <mat-checkbox formControlName="moreDays" labelPosition="before">Più giorni</mat-checkbox>
    </section>
  }

    <!-- seleziona periodo  -->
    <div class="input-group">
      <!-- data inizio -->
      <div class="input-container">
        <p class="date">Data inizio* :</p>
        <mat-form-field class="fill" [appearance]="form.get('startDate')?.value ? 'fill' : 'outline'">
          <input 
            matInput 
            [matDatepicker]="pickerstartDate"  
            formControlName="startDate" 
            [min]="minDate">
          <mat-datepicker-toggle matIconSuffix [for]="pickerstartDate"></mat-datepicker-toggle>
          <mat-datepicker touchUi #pickerstartDate></mat-datepicker>
        </mat-form-field>
        <mat-error *ngIf="form.get('startDate')?.invalid && form.get('startDate')?.touched">
          Campo obbligatorio.
        </mat-error>
      </div>

      @if(form.get('moreDays').value){
        <!-- data fine -->
        <div class="input-container">
          <p class="date">Data fine* :</p>
          <mat-form-field class="fill" [appearance]="form.get('endDate')?.value ? 'fill' : 'outline'">
            <input 
              matInput 
              [matDatepicker]="pickerendDate"  
              formControlName="endDate" 
              [min]="minDate">
            <mat-datepicker-toggle matIconSuffix [for]="pickerendDate"></mat-datepicker-toggle>
            <mat-datepicker touchUi #pickerendDate></mat-datepicker>
          </mat-form-field>
          <mat-error *ngIf="form.get('endDate')?.invalid && form.get('endDate')?.touched">
            Campo obbligatorio.
          </mat-error>
        </div>
      }
    </div>

    <!-- seleziona orario -->
    <!-- <div class="form-grid"> -->
      <div class="input-group">
        <div class="input-container">
          <label for="startTime">Inizio turno*:</label>
          <mat-form-field class="time-field" appearance="outline">
            <input matInput type="time" formControlName="startTime" id="startTime" />
          </mat-form-field>
          <mat-error *ngIf="form.get('startTime')?.hasError('required') && form.get('startTime')?.touched">Campo obbligatorio.</mat-error>
        </div>

        <div class="input-container">
          <label for="endTime">Fine turno* :</label>
          <mat-form-field class="time-field" appearance="outline">
            <input matInput type="time" formControlName="endTime" id="closingTime" />
          </mat-form-field>
          <mat-error *ngIf="form.get('endTime')?.hasError('required') && form.get('endTime')?.touched">Campo obbligatorio.</mat-error>
          <mat-error *ngIf="form.hasError('timeAfter') && (form.get('endTime')?.touched || form.get('startTime')?.touched)">
          L'orario di fine turno deve essere successivo all'orario di apertura.
        </mat-error>
        </div>
      </div>
    <!-- </div> -->
  </form>
</mat-dialog-content>

<mat-dialog-actions >
  <button mat-stroked-button [mat-dialog-close]="" cdkFocusInitial>Annulla</button>
  <button mat-flat-button (click)="onConfirm()">Conferma</button>
</mat-dialog-actions>
